import React, { useEffect } from 'react';
import thunkActions from '../../../../../store/actions/thunkActions';
import { useDispatch, useSelector } from 'react-redux';
import carConfigurationSelectors from '../../../../../store/selectors/carConfigurationSelectors';
import customiseSelectors from '../../../../../store/selectors/customiseSelectors';
import TechnicalSpecificationsContainer from './TechnicalSpecificationsContainer';
import StandardFeaturesContainer from './StandardFeaturesContainer';
import variantSpecificationsSelectors from '../../../../../store/selectors/variantSpecificationsSelectors';
import ThemedErrorMessage from '../../../../../../common/components/presentation/error/ThemedErrorMessage';
import { Box } from '@material-ui/core';

const SpecificationsContentContainer = () => {
  const dispatch = useDispatch();
  const error = useSelector(variantSpecificationsSelectors.getVariantErrorState);
  const variantId = useSelector(carConfigurationSelectors.getSelectedVariant);
  const isSpecificationsFeaturesModalOpen = useSelector(customiseSelectors.getSpecificationsFeaturesModal);
  const currentSpecificationsVariantId = useSelector(variantSpecificationsSelectors.getCurrentSpecificationsVariantId);

  useEffect(() => {
    if (isSpecificationsFeaturesModalOpen && variantId !== currentSpecificationsVariantId) {
      dispatch(thunkActions.fetchVariantSpecifications(variantId));
    }
  }, [isSpecificationsFeaturesModalOpen]);

  return (
    <Box data-test={'container:specifications_and_features'}>
      {error ? (
        <ThemedErrorMessage error={error} fullPage={true} message={'spc.common.error.general'} />
      ) : (
        <>
          <TechnicalSpecificationsContainer />
          <StandardFeaturesContainer />
        </>
      )}
    </Box>
  );
};

export default SpecificationsContentContainer;
